import { Component } from "@angular/core";
import { EventRiskControlModel } from "@app/event/shared/event-risk-control-model";
import { BaseEventRiskControl } from "../event-risk-control/event-risk-control.component";
import { Observable } from "rxjs";
import { RiskLinkableComponent } from "@app/risk/pages/risk-linkable/risk-linkable.component";

@Component({
    selector: "event-risk",
    templateUrl: "./event-risk.component.html",
    styleUrls: ["./event-risk.component.scss"],
    imports: [RiskLinkableComponent],
})
export class EventRiskComponent extends BaseEventRiskControl {

    getLinkable(guid: string, organizationId: number): Observable<EventRiskControlModel[]> {
        return this._eventDS.getLinkableRisks(guid, organizationId);
    }

    linkedItemsChanged(linked: EventRiskControlModel[]) {
        this.eventModel.RiskIdList = linked.map((x) => x.id);
        this.eventModel.Risks = linked;

        this.linkChanged.emit();
    }

    getLinked(): number[] {
        return this.eventModel.RiskIdList;
    }
}
